import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FiMenu, FiX } from "react-icons/fi";
import { navLinks, profile } from "../../data/profile";
import ThemeToggle from "../ui/ThemeToggle";

function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  // Add a border/shadow once the page moves away from the top.
  useEffect(() => {
    function handleScroll() {
      setIsScrolled(window.scrollY > 8);
    }

    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Close the mobile menu on Escape.
  useEffect(() => {
    if (!isOpen) return undefined;

    function handleKeyDown(event) {
      if (event.key === "Escape") setIsOpen(false);
    }

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [isOpen]);

  const closeMenu = () => setIsOpen(false);
  const initials = profile.name
    .split(" ")
    .map((part) => part[0])
    .join("");

  return (
    <header className={`nav${isScrolled ? " nav--scrolled" : ""}`}>
      <nav className="container nav__inner" aria-label="Main navigation">
        <Link to="/" className="nav__brand" onClick={closeMenu}>
          {initials}
          <span className="nav__brand-dot">.</span>
        </Link>

        <ul className="nav__links" data-open={isOpen}>
          {navLinks.map((link) => (
            <li key={link.id}>
              <Link
                className="nav__link"
                to={{ pathname: "/", hash: `#${link.id}` }}
                onClick={closeMenu}
              >
                {link.label}
              </Link>
            </li>
          ))}
          <li>
            <Link className="nav__link" to="/resume" onClick={closeMenu}>
              Resume
            </Link>
          </li>
        </ul>

        <div className="nav__actions">
          <ThemeToggle />
          <button
            type="button"
            className="nav__toggle"
            onClick={() => setIsOpen((open) => !open)}
            aria-expanded={isOpen}
            aria-label={isOpen ? "Close menu" : "Open menu"}
          >
            {isOpen ? <FiX /> : <FiMenu />}
          </button>
        </div>
      </nav>
    </header>
  );
}

export default Navbar;
